import { useLayoutEffect } from 'react';
import { gameOverlayPause } from '../game-overlay-pause';
export function useGameOverlayPause(open = true) {
  useLayoutEffect(() => open ? gameOverlayPause.acquire() : undefined, [open]);
}
